<template lang="pug">
div
  .sidebar-layout__toolbar
    button.btn.btn--brand(
      @click="modals.showFilters = true")
      font-awesome-icon.mr-1(
        size="sm"
        icon="filter")
      span {{ isMobile ? 'base.filter' : 'actions.add_filter' | translate }}

    v-dialog(
      max-width="450"
      v-model="modals.showFilters")
      filters-modal(
        @close="modals.showFilters = false")

    button.btn.btn--brand.ml-2(
      v-permission-hide="permissions.create_accounting"
      @click="modals.showCreateNew = true")
      font-awesome-icon.mr-1(
        size="sm"
        icon="plus")
      span {{ isMobile ? 'actions.create_mobile' : 'actions.add_storage' | translate }}

    v-dialog(
      max-width="450"
      v-model="modals.showCreateNew")
      create-modal(
        :is-mobile="isMobile"
        @close="closeModalCreate")

  navigation

  //- FOR DESKTOP AND TABLETS
  template(v-if="!isMobile")
    supplies-table

  //- FOR MOBILE ONLY
  template(v-if="isMobile")
    supplies-table-mobile

</template>

<script>
import { mapGetters } from 'vuex'

import adaptationMixin from '@/mixins/adaptation.mixin'

import Navigation from '../common/Navigation'

import FiltersModal from './modals/FiltersModal'
import CreateModal from './modals/CreateModal.vue'
import permissions from '@/util/permissions'

const SuppliesTable = () => import('./SuppliesTable.vue')
const SuppliesTableMobile = () => import('./SuppliesTableMobile.vue')

export default {
  name: 'StorageReceiving',

  mixins: [adaptationMixin],

  components: {
    Navigation,
    SuppliesTable,
    SuppliesTableMobile,
    FiltersModal,
    CreateModal
  },

  data: () => ({
    modals: {
      showFilters: false,
      showCreateNew: false
    },
    permissions: permissions
  }),

  computed: {
    ...mapGetters([
      'hasSuppliesFilters'
    ])
  },

  methods: {
    closeModalCreate () {
      this.modals.showCreateNew = false
      this.$router.go(0)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
